<page-section [page]="page" [section]="section" [index]="index" [editMode]="editMode" [modelType]="modelType" *ngFor="let section of sections; let index = index"></page-section>
<add-section *ngIf="editMode" [page]="page" [modelType]="modelType"></add-section>
